<template>
  <div class="home">
    <img alt="EMS logo" src="../assets/image/avatar.png">
    <HelloWorld :msg="msg"/>
  </div>
</template>

<script>
// @ is an alias to /src
import HelloWorld from '../components/HelloWorld.vue'

export default {
  name: 'Home',
  components: {
    HelloWorld
  },
  data(){
    return{
      msg: '欢迎使用银信普惠业务管理系统'
    }
  }
}
</script>
<style scoped>
  .home{
    text-align: center;
    margin-top: 10%;
  }
</style>
